export class CloseViewEvent extends Event {
  static readonly eventName = 'close-view';
  onDisconnect?: () => void;

  constructor() {
    super(CloseViewEvent.eventName, {
      bubbles: true,
      composed: true,
      cancelable: false,
    });
  }
}

declare global {
  interface HTMLElementEventMap {
    [CloseViewEvent.eventName]: CloseViewEvent;
  }
}